const ACCESS_TOKEN_KEY = "vovka_access_token";

export function getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token) {
    if (token) {
        localStorage.setItem(ACCESS_TOKEN_KEY, token);
    } else {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
    }
}

export function clearAccessToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function isAuthenticated() {
    return !!getAccessToken();
}

// Decode JWT to get UUID (payload is base64 encoded)
export function getUserUuidFromToken() {
    const token = getAccessToken();
    if (!token) return null;

    try {
        const payload = token.split(".")[1];
        const decoded = JSON.parse(atob(payload));
        return decoded.clientUuid;
    } catch (e) {
        console.error("Failed to decode token:", e);
        return null;
    }
}
